export default __webpack_public_path__ + "static/media/Icon material-date-range.ed9ddec7.svg";